import {lazyWithRetry} from '../lazyWithRetry/lazyWithRetry';

export const LazyZapier = lazyWithRetry(() => import('./zapier'));
